const swiperComparisonBlock = new Swiper('.column-block__contents', {
  loop: true,
  slidesPerView: 1.2,
  spaceBetween: 12,
  pagination: {
    el: '.com-block-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: `.swiper-button-next-com-block`,
    prevEl: `.swiper-button-prev-com-block`,
    enabled: true,
  },
  breakpoints: {
    581: {
      slidesPerView: 2,
    },
  }
});

const swiperComparisonTableBlock = new Swiper('.column-block-tbl__contents', {
  loop: true,
  slidesPerView: 1.78,
  spaceBetween: 12,
  pagination: {
    el: '.tbl-block-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next-tbl-block',
    prevEl: '.swiper-button-prev-tbl-block',
    enabled: true,
  },
  breakpoints: {
    981: {
      slidesPerView: 3,
    }
  },
});